import { ChangeDetectorRef, Component, HostBinding, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
@Component({
    selector: 'ham-badge-toggle',
    template: `
        <span
            hamBadge
            [color]="color"
            [icon]="icon"
            (click)="handleClick($event)"
            [class.active]="value"
            [class.inactive]="!value"
            hasCancelIcon="true"
        >
            <ng-content></ng-content>
        </span>
    `,
    styleUrls: ['./badgeToggle.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => HamBadgeToggleComponent),
            multi: true,
        },
    ],
})
export class HamBadgeToggleComponent implements ControlValueAccessor {
    @Input() icon: string | null = null;
    @Input() color: 'primary' | 'green' | 'yellow' | 'purple' | 'red' = 'primary';

    @HostBinding('class') get hostClasses(): string {
        return `ham-badge-toggle ${this.color}`;
    }

    value: boolean = false; // This will hold the value of the form control
    isClicked = false;

    private onChange = (value: any) => {};
    private onTouched = () => {};

    constructor(private cdr: ChangeDetectorRef) {}

    // Implement ControlValueAccessor methods
    writeValue(value: any): void {
        this.value = !!value; // Ensure value is boolean
    }

    registerOnChange(fn: any): void {
        this.onChange = fn; // Save the reference to propagate changes
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn; // Save the reference to mark as touched
    }

    handleClick(event: Event) {
        if (this.isClicked) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        this.isClicked = true; // Temporarily disable button

        // Toggle the value and propagate changes
        this.value = !this.value;
        this.onChange(this.value);
        this.onTouched();

        // Re-enable the button after a delay (e.g., 150 milliseconds)
        setTimeout(() => {
            this.isClicked = false;
            this.cdr.detectChanges(); // Manually trigger change detection
        }, 150);
    }
}
